var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _rect3, _path11, _path12, _path13, _path14, _path15, _path16, _rect4, _path17, _rect5, _path18, _rect6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersistenceIntermittentFasting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 138,
    viewBox: "0 0 282 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F74A4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1592 56.7373L20.2512 62.8293C22.1738 64.7519 25.2909 64.7519 27.2135 62.8293V62.8293C29.136 60.9067 29.136 57.7896 27.2135 55.867L21.1215 49.775",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3809 61.959V61.959C20.8228 63.4009 23.1606 63.4009 24.6026 61.959L26.3431 60.2184C27.7851 58.7765 27.7851 56.4386 26.3431 54.9967V54.9967",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2138 62.829L17.6406 53.2559",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1689 63.8731L28.2576 61.7844L42.8784 75.0128L46.3595 78.4939C47.3208 79.4552 47.3208 81.0138 46.3595 81.975V81.975C45.3982 82.9363 43.8397 82.9363 42.8784 81.975L39.3972 78.4939L26.1689 63.8731Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0751 63.6284C41.732 65.9716 37.8843 65.9229 35.4811 63.5196C33.0779 61.1164 33.0291 57.2687 35.3723 54.9256C37.7154 52.5824 43.1686 48.5797 46.7948 52.2059C50.421 55.8321 46.4183 61.2853 44.0751 63.6284Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3076 61.6044L37.3962 63.6931L24.1679 78.3139L20.6868 81.795C19.7255 82.7563 18.1669 82.7563 17.2056 81.7951V81.7951C16.2443 80.8338 16.2443 79.2752 17.2056 78.3139L20.6868 74.8328L35.3076 61.6044Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 35,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F74A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.159 56.7373L116.251 62.8293C118.174 64.7519 121.291 64.7519 123.213 62.8293V62.8293C125.136 60.9067 125.136 57.7896 123.213 55.867L117.121 49.775",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.381 61.959V61.959C116.823 63.4009 119.161 63.4009 120.603 61.959L122.343 60.2184C123.785 58.7765 123.785 56.4386 122.343 54.9967V54.9967",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.214 62.829L113.641 53.2559",
    stroke: "white",
    strokeWidth: 2.46154,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.169 63.8731L124.258 61.7844L138.878 75.0128L142.36 78.4939C143.321 79.4552 143.321 81.0138 142.36 81.975V81.975C141.398 82.9363 139.84 82.9363 138.878 81.975L135.397 78.4939L122.169 63.8731Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M140.075 63.6284C137.732 65.9716 133.884 65.9229 131.481 63.5196C129.078 61.1164 129.029 57.2687 131.372 54.9256C133.715 52.5824 139.169 48.5797 142.795 52.2059C146.421 55.8321 142.418 61.2853 140.075 63.6284Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.308 61.6044L133.396 63.6931L120.168 78.3139L116.687 81.795C115.725 82.7563 114.167 82.7563 113.206 81.7951V81.7951C112.244 80.8338 112.244 79.2752 113.206 78.3139L116.687 74.8328L131.308 61.6044Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184,
    y: 27,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F74A4A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.699 54.1709L209.314 61.7859C211.717 64.1891 215.614 64.1891 218.017 61.7859V61.7859C220.42 59.3827 220.42 55.4863 218.017 53.083L210.402 45.468",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M208.227 60.6982V60.6982C210.029 62.5007 212.951 62.5007 214.754 60.6982L216.929 58.5225C218.732 56.7201 218.732 53.7978 216.929 51.9954V51.9954",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M218.017 61.7858L206.051 49.8193",
    stroke: "white",
    strokeWidth: 3.07692,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.711 63.0907L219.322 60.4798L237.598 77.0152L241.949 81.3666C243.151 82.5683 243.151 84.5165 241.949 85.7181V85.7181C240.748 86.9197 238.8 86.9197 237.598 85.7181L233.247 81.3666L216.711 63.0907Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M239.093 62.7848C236.165 65.7137 231.355 65.6528 228.351 62.6488C225.347 59.6448 225.286 54.8351 228.215 51.9062C231.144 48.9773 237.96 43.9739 242.493 48.5067C247.026 53.0394 242.022 59.8559 239.093 62.7848Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M228.134 60.2551L230.745 62.8659L214.209 81.1419L209.858 85.4933C208.656 86.6949 206.708 86.6949 205.507 85.4933V85.4933C204.305 84.2917 204.305 82.3435 205.507 81.1419L209.858 76.7905L228.134 60.2551Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 97L156.5 101L163.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 97L60.5 101L67.5 93",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 81,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 254,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 262,
    cy: 97,
    r: 2,
    fill: "#24284E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 156,
    cy: 134,
    r: 2,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 20,
    r: 2,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 1.5,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 114.5,
    r: 1.5,
    fill: "white"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.5,
    cy: 124.5,
    r: 1.5,
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 27.5,
    r: 1.5,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176 14L184.5 25.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M258 8L250.5 18.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231 121.5L234 136",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersistenceIntermittentFasting);
export default __webpack_public_path__ + "static/media/persistence-intermittent-fasting.497a651dfa2944e4c0e739fd6d5f2328.svg";
export { ForwardRef as ReactComponent };